module.exports = __webpack_public_path__ + "img/ghb.fc3cf6f7.png";